 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML9781137279125_01_PRE from '@/components/html/9781137279125_01_Pre'
 import HTML9781137279125_02_CH01 from '@/components/html/9781137279125_02_Ch01'
 import HTML9781137279125_03_CH02 from '@/components/html/9781137279125_03_Ch02'
 import HTML9781137279125_04_CH03 from '@/components/html/9781137279125_04_Ch03'
 import HTML9781137279125_05_CH04 from '@/components/html/9781137279125_05_Ch04'
 import HTML9781137279125_06_CH05 from '@/components/html/9781137279125_06_Ch05'
 import HTML9781137279125_07_CH06 from '@/components/html/9781137279125_07_Ch06'
 import HTML9781137279125_08_CH07 from '@/components/html/9781137279125_08_Ch07'
 import HTML9781137279125_09_CH08 from '@/components/html/9781137279125_09_Ch08'
 import HTML9781137279125_10_CH09 from '@/components/html/9781137279125_10_Ch09'
 import HTML9781137279125_11_CH10 from '@/components/html/9781137279125_11_Ch10'
 import HTML9781137279125_12_CH11 from '@/components/html/9781137279125_12_Ch11'
 import HTML9781137279125_13_EPIL from '@/components/html/9781137279125_13_Epil'
 import HTML9781137279125_14_TIM from '@/components/html/9781137279125_14_Tim'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML9781137279125_15_BIB from '@/components/html/9781137279125_15_Bib'
 import HTML9781137279125_16_IND from '@/components/html/9781137279125_16_Ind'
 import HTML9781137279125_00_PLATES from '@/components/html/9781137279125_00_Plates'
 import HTMLCOPY from '@/components/html/copy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/cover",
 			"name" : "html/cover",
 			"component" : HTMLCOVER
 		},
 		{
 			"path" : "/html/love_1",
 			"name" : "html/love_1",
 			"component" : HTMLLOVE_1
 		},
 		{
 			"path" : "/html/9781137279125_01_Pre",
 			"name" : "html/9781137279125_01_Pre",
 			"component" : HTML9781137279125_01_PRE
 		},
 		{
 			"path" : "/html/9781137279125_02_Ch01",
 			"name" : "html/9781137279125_02_Ch01",
 			"component" : HTML9781137279125_02_CH01
 		},
 		{
 			"path" : "/html/9781137279125_03_Ch02",
 			"name" : "html/9781137279125_03_Ch02",
 			"component" : HTML9781137279125_03_CH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js